module.exports = __webpack_public_path__ + "files/70567975c3c1450d033247562fcfe80a.png";